module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-ties-remnants.98d277f1.png";